export const ageFromDob = (dob) => {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  if (now.getMonth() < d.getMonth() || (now.getMonth() === d.getMonth() && now.getDate() < d.getDate())) age -= 1;
  return age;
};
export const isAdoAge = (age) => age !== null && age >= 12 && age <= 17;
export const SESSION_TYPE_LABELS = { initial: "Entretien initial", suivi_tcc: "Séance de suivi TCC", therapie_couple: "Séance de thérapie de couple", suivi_tcc_ado: "Suivi TCC enfants & ados (12-17 ans)" };
